module.exports = __webpack_public_path__ + "static/media/Petrenko Reinigung HomePage.94edb0bc.jpg";